import { FunctionComponent } from "react";

import useOldAccountDetails from "./useOldAccountDetails";

import {
  STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS,
  STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT,
  STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT,
  STEP_OLD_ACCOUNT_PROVIDER_SEARCH,
  STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN,
  STEP_OLD_ACCOUNT_SPONSOR_NAME,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED,
  STEP_OLD_ACCOUNT_CONFIRM,
  STEP_OLD_ACCOUNT_FLASH_LOADING,
} from "../../class/transferDetails";

import SponsorNameScreen from "./screens/SponsorName";
import HaveAccountStatementScreen from "./screens/HaveAccountStatement";
import OldAccountEmploymentDetails from "./screens/OldAccountEmploymentDetails";
import AccountStatementUpload from "./screens/AccountStatementUpload";
import AccountStatementSucceed from "./screens/AccountStatementSucceed";
import HaveAnotherAccount from "./screens/HaveAnotherAccount";
import OldAccountFinishScreen from "./screens/OldAccountFinishScreen";
import ProviderSearch from "./screens/ProviderSearch";
import LoadingScreen from "../general/loading-screen";
import ProviderKnownScreen from "./screens/ProviderKnownScreen";
import ConfirmOldAccount from "./screens/ConfirmOldAccount";
import FlashLoadingScreen from "./screens/FlashLoadingScreen";

const OldAccountPane: FunctionComponent = () => {
  const props = useOldAccountDetails();

  if (props.isLoading) {
    return <LoadingScreen loadingScreenMessage="" />;
  }

  switch (props.currentSourceAccountStep) {
    case STEP_OLD_ACCOUNT_SPONSOR_NAME:
      return <SponsorNameScreen {...props} />;
    case STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT:
      return <HaveAccountStatementScreen {...props} />;
    case STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS:
      return <OldAccountEmploymentDetails {...props} />;
    case STEP_OLD_ACCOUNT_PROVIDER_SEARCH:
      return <ProviderSearch {...props} />;
    case STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN:
      return <ProviderKnownScreen {...props} />;
    case STEP_OLD_ACCOUNT_UPLOAD_STATEMENT:
      return <AccountStatementUpload {...props} />;
    case STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED:
      return <AccountStatementSucceed {...props} />;
    case STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT:
      return <HaveAnotherAccount {...props} />;
    case STEP_OLD_ACCOUNT_CONFIRM:
      return <ConfirmOldAccount {...props} />;
    case STEP_OLD_ACCOUNT_FLASH_LOADING:
      return <FlashLoadingScreen {...props} />;
    default:
      return <OldAccountFinishScreen {...props} />;
  }
};
export default OldAccountPane;
